export function canonicalizeCmsUrl(cmsUrl: string): string {
  if (!cmsUrl) {
    return cmsUrl;
  }

  try {
    const url = new URL(cmsUrl);
    const hostname = url.hostname.toLowerCase();

    if (hostname.endsWith('.wpengine.com')) {
      url.hostname = `${hostname.slice(
        0,
        -'.wpengine.com'.length,
      )}.wpenginepowered.com`;
    }

    return url.toString().replace(/\/$/, '');
  } catch {
    return cmsUrl;
  }
}
